import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class UnauthorizedException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'UnauthorizedException';
  }

  static fromError(error: HttpErrorResponse | Error): UnauthorizedException {
    return new this(error.message, error);
  }
}
